import { __assign, __rest } from "tslib";
import * as React from 'react';
export var Form = function (_a) {
    var onSubmit = _a.onSubmit, props = __rest(_a, ["onSubmit"]);
    var submit = React.useCallback(function (ev) {
        ev.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }, [onSubmit]);
    return React.createElement("form", __assign({}, props, { onSubmit: submit }));
};
//# sourceMappingURL=index.js.map